import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NavigationBar extends Component {
    render() {
        return (
            <div className="header bg-white fixed-top">
                <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top navbar-top">
                    <Link to={'/'}>
                        <img src="/resources/images/iphone-logo128.png" alt="" style={{ height: 37 }} />
                    </Link>
                    <button className="navbar-toggler navbar-top-sm" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon navbar-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarToggler">
                        <ul className="mt-2 mr-auto mt-lg-0"></ul>
                        <ul className="navbar-nav my-2 my-lg-0" id="navbar-example">
                            {/* <li className="nav-item">
                                <a className="nav-link top-item" href="index.html">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link top-item" href="http://localhost/open-api/view/index.html#about">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link top-item" href="http://localhost/open-api/view/index.html#service">Service</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link top-item" href="http://localhost/open-api/view/index.html#showcase">Showcase</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link top-item" href="http://localhost/open-api/view/index.html#contact">Contact</a>
                            </li>
                            <li className="nav-item bd-item"></li> */}
                            <li className="nav-item active">
                                <a className="nav-link top-item" href="#">API Explorer</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/views/menu/NavigationBar.jsx